module.exports = __webpack_public_path__ + "img/success.1969c4b2.webp";